import { getOktaAccessToken } from "../LocalStorage";
import { request } from "./Api";

const BANK_ACCOUNT_API_URL = process.env.REACT_APP_BANK_ACCOUNT_API_BASE_URL;
const getAllDepositoryAssignments = (): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: BANK_ACCOUNT_API_URL + "/depository-assignments",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

const saveAllDepositoryAssignmentsAccounts = (
  depositoryAssignments: any
): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "POST",
    url: BANK_ACCOUNT_API_URL + "/depository-assignments",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: depositoryAssignments,
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

const getAllUnassignedParentAccounts = (): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: BANK_ACCOUNT_API_URL + "/depository-assignments/unassigned-parents",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

export {
  getAllDepositoryAssignments,
  saveAllDepositoryAssignmentsAccounts,
  getAllUnassignedParentAccounts,
};
